import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from '../../../components/feature/ThemeToggle';
import { JobOsLogo } from '../../../components/JobOsLogo';
import { useTheme } from '../../../contexts/ThemeContext';

export default function BlogNavigation() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
          ? 'bg-white/95 dark:bg-[#0A0E1A]/95 backdrop-blur-md shadow-sm border-b border-gray-200 dark:border-[#2D3148]'
          : 'bg-white/95 dark:bg-[#0A0E1A]/95 backdrop-blur-md border-b border-gray-200 dark:border-[#2D3148]'
          }`}
      >
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3 group cursor-pointer">
              <JobOsLogo variant="sidebar" showWordmark={true} lightMode={theme === 'light'} />
            </Link>

            <div className="hidden lg:flex items-center gap-6">
              <Link to="/#features" className="text-sm font-medium text-gray-600 dark:text-[#94A3B8] hover:text-gray-900 dark:hover:text-white transition-colors whitespace-nowrap">Features</Link>
              <Link to="/#how-it-works" className="text-sm font-medium text-gray-600 dark:text-[#94A3B8] hover:text-gray-900 dark:hover:text-white transition-colors whitespace-nowrap">How It Works</Link>
              <Link to="/#pricing" className="text-sm font-medium text-gray-600 dark:text-[#94A3B8] hover:text-gray-900 dark:hover:text-white transition-colors whitespace-nowrap">Pricing</Link>
              <Link to="/#extension" className="text-sm font-medium text-gray-600 dark:text-[#94A3B8] hover:text-gray-900 dark:hover:text-white transition-colors whitespace-nowrap">Chrome Extension</Link>
              <Link to="/blog" className="text-sm font-medium text-[#6366F1] whitespace-nowrap">Blog</Link>
            </div>

            <div className="hidden lg:flex items-center gap-3">
              <ThemeToggle />
              <a
                href="https://app.jobos.dev/auth"
                className="text-gray-600 dark:text-[#94A3B8] hover:text-gray-900 dark:hover:text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Sign In
              </a>
              <a
                href="https://app.jobos.dev/auth"
                className="px-5 py-2.5 bg-[#6366F1] hover:bg-[#4F46E5] text-white text-sm font-semibold rounded-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#6366F1]/30 cursor-pointer whitespace-nowrap"
              >
                Get Started Free
              </a>
            </div>

            <div className="lg:hidden flex items-center gap-2">
              <ThemeToggle />
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="w-10 h-10 flex items-center justify-center text-gray-600 dark:text-[#94A3B8] cursor-pointer"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-white/98 dark:bg-[#0A0E1A]/98 backdrop-blur-xl flex flex-col items-center justify-center gap-8 px-6">
            <Link to="/#features" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-semibold text-gray-900 dark:text-white hover:text-[#6366F1] transition-colors cursor-pointer whitespace-nowrap">Features</Link>
            <Link to="/#how-it-works" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-semibold text-gray-900 dark:text-white hover:text-[#6366F1] transition-colors cursor-pointer whitespace-nowrap">How It Works</Link>
            <Link to="/#pricing" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-semibold text-gray-900 dark:text-white hover:text-[#6366F1] transition-colors cursor-pointer whitespace-nowrap">Pricing</Link>
            <Link to="/#extension" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-semibold text-gray-900 dark:text-white hover:text-[#6366F1] transition-colors cursor-pointer whitespace-nowrap">Chrome Extension</Link>
            <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-semibold text-[#6366F1] whitespace-nowrap">Blog</Link>
            <div className="flex flex-col gap-4 mt-8 w-full max-w-xs">
              <a
                href="https://app.jobos.dev/auth"
                className="h-12 px-6 border border-gray-200 dark:border-[#2D3148] text-gray-900 dark:text-white text-lg font-medium rounded-full flex items-center justify-center cursor-pointer whitespace-nowrap hover:border-[#6366F1] transition-colors"
              >
                Sign In
              </a>
              <a
                href="https://app.jobos.dev/auth"
                className="h-12 px-6 bg-[#6366F1] text-white text-lg font-semibold rounded-full flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap hover:bg-[#4F46E5] transition-colors"
              >
                Get Started Free
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
